// extracted by mini-css-extract-plugin
export default {"mobile":"ImageColorTabContent_mobile__LlCzc"};